// 导航链接配置
// 统一管理全站的导航链接，便于维护和复用

export interface NavItem {
  path: string;
  label: string;
  isUnderConstruction?: boolean; // 是否为建设中状态
}

// 主导航链接（Header中使用）
export const MAIN_NAV_ITEMS: Readonly<NavItem[]> = Object.freeze([
  { path: "/", label: "首页" },
  { path: "/category", label: "选题分类" },
  { path: "/news", label: "新闻动态" },
  { path: "/exhibition", label: "线上展览" },
  { path: "/industry", label: "产业转化" },
  { path: "/history", label: "往届回顾" },
  { path: "/about", label: "关于我们" },
]);

// 页脚导航链接（Footer中使用）
export const FOOTER_NAV_ITEMS: Readonly<NavItem[]> = Object.freeze([
  { path: "/", label: "首页" },
  { path: "/category", label: "选题分类" },
  { path: "/exhibition", label: "线上展览" },
  // { path: "/review", label: "专家评审", isUnderConstruction: true },
  { path: "/industry", label: "产业转化", isUnderConstruction: true },
  { path: "/about", label: "关于我们" },
  { path: "/about/vi", label: "UGD品牌VI" },
  { path: "/about/materials", label: "UGD项目资料" },
  { path: 'https://docs.qq.com/doc/DRmJVUWNaSUJvSmdj', label: 'UGD选题资料2026' },
  // { path: "/notice", label: "通知公告" },
]);
